import { Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import { Hub } from 'aws-amplify/utils';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import { NotificationContainer } from './components/common/NotificationContainer';
import { AppLayout } from './layouts/AppLayout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { MappingList } from './pages/MappingList';
import { MappingDetail } from './pages/MappingDetail';
import { CreateMapping } from './pages/CreateMapping';
import DocTypeList from './pages/DocTypeList';
import DocTypeDetail from './pages/DocTypeDetail';
import DocTypeEdit from './pages/DocTypeEdit';
import { TenantList } from './pages/TenantList';
import { TenantDocTypes } from './pages/TenantDocTypes';
import { TenantDocTypeConfig } from './pages/TenantDocTypeConfig';
import { NotFound } from './pages/NotFound';
import { Lab } from './pages/Lab';
import { useAuthStore } from './store/auth';

export function App() {
  const { handleAuthCallback, checkSession } = useAuthStore();

  useEffect(() => {
    // Check for existing session on mount
    checkSession();

    // Listen for auth events
    const hubListener = Hub.listen('auth', ({ payload }) => {
      switch (payload.event) {
        case 'signInWithRedirect':
          handleAuthCallback();
          break;
        case 'signInWithRedirect_failure':
          console.error('SSO sign in failed:', payload.data);
          break;
        case 'tokenRefresh':
          console.log('Token refreshed');
          break;
        case 'tokenRefresh_failure':
          console.error('Token refresh failed');
          break;
      }
    });

    return () => hubListener();
  }, [handleAuthCallback, checkSession]);

  return (
    <>
      <NotificationContainer />
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route element={<ProtectedRoute />}>
          <Route element={<AppLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/mappings" element={<MappingList />} />
            <Route path="/mappings/create" element={<CreateMapping />} />
            <Route path="/mappings/:key" element={<MappingDetail />} />
            <Route path="/doctypes" element={<DocTypeList />} />
            <Route path="/doctype/:id" element={<DocTypeDetail />} />
            <Route path="/doctype/:id/edit" element={<DocTypeEdit />} />
            <Route path="/tenants" element={<TenantList />} />
            <Route path="/tenants/:tenantId/doctypes" element={<TenantDocTypes />} />
            <Route path="/tenants/:tenantId/doctype/:docType" element={<TenantDocTypeConfig />} />
            <Route path="/lab" element={<Lab />} />
            {/* Catch-all: any undefined route requires auth */}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
